import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material';
import theme from 'src/style-system/theme';
import { EXIT_INTENT_BG_IMG } from '@utils/data';

export const useStyles = makeStyles({
  container: {
    height: '100vh',
    width: '100%',
    backgroundColor: alpha(theme.palette.cinnamon.main, 0.5),
  },

  mainContainer: {
    padding: '5px',
    display: 'flex',
    borderRadius: '50px',
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.whitePepper.main,
    height: '80vh',
    width: '100%',
    maxWidth: '345px',
    maxHeight: '550px',

    [theme.breakpoints.up('md')]: {
      height: '80vh',
      maxWidth: '800px',
      maxHeight: '600px',
    },

    [theme.breakpoints.up('lg')]: {
      width: '800px',
    },
  },

  leftContainer: {
    borderRadius: '50px 0 0 50px',
    overflow: 'hidden',

    //flex: 1,
    flexBasis: '50%',
    position: 'relative',
    width: '100%',
    backgroundImage: `url(${EXIT_INTENT_BG_IMG})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    position: 'relative',
    width: '100%',
    padding: '40px 25px',

    [theme.breakpoints.up('md')]: {
      padding: '25px 25px 25px 15px',
    },

    [theme.breakpoints.up('lg')]: {
      padding: '25px 40px 25px 30px ',
    },

    // to not display scroll bar
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none' /* IE and Edge */,
    scrollbarWidth: 'none' /* Firefox */,
  },

  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'auto',
  },

  pageLoaderWrapper: {
    width: '100%',
    height: '100%',
    borderRadius: '50px',
    overflow: 'hidden',
  },

  closeIcon: {
    position: 'absolute',
    top: '25px',
    right: '25px',
    color: theme.palette.garamMasala.main,
    zIndex: 10,
    transform: 'scale(1.25)',
    cursor: 'pointer',
  },

  // Email Section

  title: {
    maxWidth: '230px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '280px',
    },
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  discountBtn: {
    marginBottom: '10px !important',
    [theme.breakpoints.up('md')]: {
      marginBottom: '20px !important',
    },
  },

  noThanksText: {
    cursor: 'pointer',
    textDecoration: 'underline',
    marginBottom: '20px',

    [theme.breakpoints.up('md')]: {
      marginBottom: '50px',
    },
  },

  dTDisplayNone: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  mobDisplayNone: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  emailError: {
    position: 'relative',
    top: '-15px',
  },

  //copy section

  logoOne: {
    position: 'absolute',
    top: '-15px',
    left: '-75px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  logoTwo: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: '-50px',
      right: '-70px',
    },
  },

  copyGiftCodeFieldWrapper: {
    maxWidth: '290px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50px',
    margin: '0 auto 20px',
    [theme.breakpoints.up('sm')]: {
      width: '290px',
    },
  },

  giftCodeField: {
    padding: '5px 15px',
    border: `1px solid ${theme.palette.offWhite.main}`,
    backgroundColor: 'white',
    color: theme.palette.cumin.main,
    outline: 0,
    fontSize: '16px',
    width: '70%',
    height: '100%',
    borderTopLeftRadius: '25px',
    borderBottomLeftRadius: '25px',
    [theme.breakpoints.up('sm')]: {
      padding: '5px 25px',
    },

    '& .css-hwaby5-MuiInputBase-root-MuiInput-root': {
      pointerEvents: 'none',
    },
  },

  coptGiftCodebtn: {
    minWidth: '20% !important',
    width: '30% !important',
    borderRadius: '0px 25px 25px 0 !important',
  },
});
